import { Component, OnInit, ViewChild } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { AssigTripsService } from '../assigntrips-service/assigntrips-service';
import * as _ from 'underscore';
import { DriversService } from '../../drivers/drivers-service/drivers-service';
import { AgmMap, ControlPosition, MapTypeControlOptions } from '@agm/core';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { LevelOfServiceService } from '../../level-of-service/service/level-of-service.service';

@Component({
  selector: 'app-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.css']
})
export class PlaygroundComponent implements OnInit {
  @ViewChild("AgmMap", { static: true }) agmElement: AgmMap;
  @ViewChild('timer', { static: false }) timer;
  duration = 10 * 1000; // 10 seconds
  isShowAllTrips = false;
  user;
  todayDate;
  timeZone;
  skip = 0;
  filterdataList = [];
  tableList = [];
  trips = [];
  preDriverList;
  origin = { lat: 0.0, lng: 0.0 };
  destination = { lat: 0.0, lng: 0.0 };
  latitude: number = 36.778259;
  longitude: number = -119.417931;
  agmMap;
  geoCoder;
  mapTypeControlOptions: MapTypeControlOptions = {
    position: ControlPosition.TOP_LEFT
  };
  isResizing = false;
  serviceAreas = [];
  selectedServiceArea = [];
  driversList = [];
  selectedDriver = [];
  isShowDriver = false;
  preLevelOfServices;
  preSpaceTypes;
  preFundingSource;
  preServiceAreas;
  isShowStatusDropdown = false;
  selectedDriverDetail;
  selectedTrip;
  bounds;

  tripStatuses = [
    { label: 'Unassigned', status: 'pending', isChecked: true },
    { label: 'Assigned', status: 'hanging', isChecked: true },
    { label: 'En Route', status: 'onway', isChecked: false },
    { label: 'Arrived', status: 'arrived', isChecked: false },
    { label: 'In Progress', status: 'started', isChecked: false },
    { label: 'Completed', status: 'finished', isChecked: false },
    { label: 'Cancelled', status: 'cancelled', isChecked: false },
  ];
  constructor(
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private driverService: DriversService,
    private serviceArea: ServiceAreasService,
    private levelOfServiceService: LevelOfServiceService
  ) { }

  ngOnInit() {
    this.getUser();

  }

  ngAfterViewInit() {
    this.agmElement.mapReady
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((map) => {
        this.agmMap = map;
        this.geoCoder = new google.maps.Geocoder;
      });
  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeZone = data.timeZone;
          this.user = data;
          this.todayDate = moment().tz(this.timeZone);
          this.getDriverList();
          this.setBounds();
          this.getServiceAreas();
          this.getSpaceTypes();
          this.getLevelOfService();
          this.getFundingSources();
        }
      });
  }


  getTrips() {
    let jobStatuses = [];
    this.tripStatuses.forEach(t => {
      if (t.isChecked) {
        if (t.status === 'hanging') {
          jobStatuses.push('offered');
          jobStatuses.push('accepted');
        } else {
          jobStatuses.push(t.status);
        }
      }
    })
    if (jobStatuses && !jobStatuses.length) {
      return;
    }
    const object = {
      isShowAllTrips: this.isShowAllTrips,
      status: 'manifest',
      date: [this.todayDate.startOf("day").toISOString(), this.todayDate.endOf("day").toISOString()],
      skip: this.skip,
      jobStatuses

    };
    this.assignTripService
      .getAssignList(object)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.trips = [...data, ...this.trips];
            this.filterdataList = this.trips;
            this.tableList = this.trips;
          }
          if (data.length) {
            this.skip += data.length;
            this.getTrips();
          } else {
            this.skip = 0;
          }
        })
  }


  getDriverList() {
    this.driverService.getDrivers(this.user._id, "active")
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preDriverList = data.reduce((obj, item) => {
              obj[item._id] = item;
              return obj;
            }, {});
            this.driversList = data;
            this.getTrips();
          }
        },
        (err) => {
        }
      );
  }

  onTimerComplete(): void {
    // this.timer.init();
    this.getTrips();
  }

  getFloatingValues(point) {
    return parseFloat(point)
  }

  getNameChars(assign) {
    if (assign && assign.priorityClient && assign.priorityClient.displayName) {
      return assign.priorityClient.displayName
        .toLowerCase()
        .trim()
        .split(" ")[0];
    }
  }


  // Map Methods
  setBounds() {

    if (this.agmMap) {
      let bounds = new google.maps.LatLngBounds();
      for (const trip of this.filterdataList) {
        bounds.extend(
          new window["google"].maps.LatLng(
            trip.jobOriginLatitude,
            trip.jobOriginLongitude
          )

        );
        this.latitude = trip.jobOriginLatitude;
        this.longitude = trip.jobOriginLongitude;
      }

      this.agmMap.setCenter(bounds.getCenter());
      this.agmMap.fitBounds(bounds);
    }
  }

  setTripBounds(trip){
    if (this.agmMap) {
      this.bounds = new google.maps.LatLngBounds();

        this.bounds.extend(
          new window["google"].maps.LatLng(
            trip.jobOriginLatitude,
            trip.jobOriginLongitude
          )
        );

      this.agmMap.setCenter(this.bounds.getCenter());
      this.agmMap.fitBounds(this.bounds);
  }
  }

  setDriverBounds(driver) {
    if (this.agmMap) {
      this.bounds = new google.maps.LatLngBounds();

      this.bounds.extend(
        new window["google"].maps.LatLng(
          driver.startingPointAddress.latitude ? driver.startingPointAddress.latitude : 0,
          driver.startingPointAddress.longitude ? driver.startingPointAddress.longitude : 0
        )
      );

      this.agmMap.setCenter(this.bounds.getCenter());
      this.agmMap.fitBounds(this.bounds);
    }
  }
  startResizing(event: MouseEvent) {
    this.isResizing = true;
    const sidebarTop = document.getElementById('resizable-sidebar-top');
    const sidebarBottom = document.getElementById('resizable-sidebar-bottom');

    if (sidebarTop && sidebarBottom) {
      const initialHeightT = sidebarTop.offsetHeight;
      const initialHeightB = sidebarBottom.offsetHeight;
      const startX = event.clientY;

      const mouseMoveHandler = (e: MouseEvent) => {
        if (this.isResizing) {
          const offsetX = e.clientY - startX;
          const newHeightT = initialHeightT + offsetX;
          const newHeightB = initialHeightB - offsetX;

          if (newHeightT >= 0 && newHeightB >= 0) {
            sidebarTop.style.height = newHeightT + 'px';
            sidebarBottom.style.height = newHeightB + 'px';
          }
        }
      };

      const mouseUpHandler = () => {
        this.isResizing = false;
        document.removeEventListener('mousemove', mouseMoveHandler);
        document.removeEventListener('mouseup', mouseUpHandler);
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    }
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.serviceAreas = data;
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
            this.serviceAreas = data.map(item => ({
              ...item,
              color: this.generateColorFromId(item._id)
            }));

          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }


  onChangeServiceArea() {
  if (this.selectedServiceArea && this.selectedServiceArea.length) {
    const selectedServiceAreaIds = new Set(this.selectedServiceArea.map(area => area._id));
    const serviceAreaMap = new Map(this.serviceAreas.map(area => [area._id, area]));

    this.filterdataList = [];
    for (const trip of this.trips) {
      if (selectedServiceAreaIds.has(trip.serviceArea)) {
        const serviceArea = serviceAreaMap.get(trip.serviceArea);
        this.filterdataList.push({
          ...trip,
          color: serviceArea ? this.generateColorFromId(serviceArea._id) : '#d2042d'
        });
      }
    }
  this.tableList = this.filterdataList;
    this.setBounds();
  } else {
    this.filterdataList = [];
    this.tableList = this.trips;
  }
}


  getCount() {
    return this.filterdataList && this.filterdataList.length > 0 ? this.filterdataList : this.trips;
  }

  generateColorFromId(id: string): string {
    let hash = 0;
    for (const char of id) {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    }
    const color = (hash & 0x00FFFFFF).toString(16).toUpperCase();
    return `#${'00000'.substring(0, 6 - color.length) + color}`;
  }

  getMarkerIcon(color = '#FF0000', isSelected = false) {
    const markerColor = isSelected ? '#964B00' : color;
    const svg = `
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 24 24"
         fill="${markerColor}"
         stroke="#FFFFFF"
         stroke-width="1.5"
         height="34"
         width="34">
      <!-- Default Google Maps marker shape -->
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
    </svg>`;
    return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
  }

  getLevelOfService() {
    this.levelOfServiceService
      .getLevelOfServices({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preLevelOfServices = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getSpaceTypes() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .subscribe(data => {
        if (data) {
          this.preSpaceTypes = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getFundingSources() {
    this.assignTripService
      .getCorporateUserList()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preFundingSource = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      });
  }

  onDateChange(event) {
    this.skip = 0;
    this.clearTrips();
    this.getTrips();
  }

  clearTrips() {
    this.skip = 0;
    this.filterdataList = [];
    this.trips = [];
  }

  toggleStatusDropdown() {
    this.isShowStatusDropdown = !this.isShowStatusDropdown
  }

  onChangeStatus() {
    this.skip = 0;
    this.trips = [];
    this.filterdataList = [];
    this.getTrips();
  }

  openDriverInfo(driver) {
    this.selectedDriverDetail = driver;
    console.log("driver check",this.selectedDriverDetail);
  }
  closeDriverAddressWindow(evt) {
    this.selectedDriverDetail = null;
  }
  openTripInfo(trip) {
    if (this.selectedTrip && this.selectedTrip._id === trip._id) {
      this.closeTripInfo(null);
    } else {
      this.selectedTrip = trip;
    }
  }
  closeTripInfo(evt) {
    this.selectedTrip = null;
    if (this.selectedTrip && this.selectedTrip._id === evt._id) {
      this.closeTripInfo(null);
    }
  }

  getDriverAddress() {
    if (this.selectedDriverDetail && this.selectedDriverDetail.latitude && this.selectedDriverDetail.longitude) {
      this.getAddress(this.selectedDriverDetail.latitude, this.selectedDriverDetail.longitude);
    }
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results) {
          this.selectedDriverDetail.address = results[0].formatted_address;
        } else {
          sweetAlert('Alert', 'No Address Found', 'warning', 'Ok')
        }
      } else {
        sweetAlert('Alert', `Geocoder failed due to: ${status}`, 'warning', 'Ok')
      }
    });
  }

  selectAllServiceAreas(isEnabled) {
    if(!isEnabled){
      this.selectedServiceArea = this.serviceAreas;
    }else{
      this.selectedServiceArea = [];
    }
    this.onChangeServiceArea();

  }

  selectAllDrivers(isEnabled) {
    if(!isEnabled){
      this.selectedDriver = this.driversList;
    }else{
      this.selectedDriver = [];
    }
  }

  ngOnDestroy(): void {
  }

}
